<main class="link-hub-page">
  <section class="link-card" aria-labelledby="link-hub-title">
    <div class="brand">
      <img src="assets/logo-black.svg" alt="D&D Twogether - Flowers and more logó" />
      <p class="intro">Friss virágok, egyedi csokrok és prémium hangulat a XIII. kerületben.</p>
    </div>

    <a
      class="review-action"
      [href]="googleReviewUrl"
      target="_blank"
      rel="noopener"
      aria-label="Google értékelés írása a Twogether Flowers számára"
    >
      <span class="review-mark" aria-hidden="true">G</span>
      <span class="review-copy">
        <span>Google értékelés</span>
        <strong>Értékelj minket Google-on</strong>
      </span>
    </a>

    <a
      class="shop-action"
      [href]="webshop"
      target="_blank"
      rel="noopener"
      aria-label="D&D Twogether webshop megnyitása"
    >
      <span class="shop-mark" aria-hidden="true">shop</span>
      <span class="shop-copy">
        <span>Webshop</span>
        <strong>Rendelés online</strong>
      </span>
    </a>

    <div class="primary-actions" aria-label="Gyors műveletek">
      <a class="hero-action call" [href]="phoneHref">
        <span>Hívás most</span>
        <strong>{{ phoneDisplay }}</strong>
      </a>
      <a class="hero-action save" [href]="contactVcardUrl" download="twogether-flower.vcf">
        <span>Kontakt mentése</span>
        <strong>1 kattintással</strong>
      </a>
    </div>

    <div class="link-list" aria-label="Twogether Flowers linkek">
      <a class="link-row" href="https://instagram.com/twogetherflowers" target="_blank" rel="noopener">
        <img src="assets/instagram-black-icon.svg" alt="" aria-hidden="true" />
        <span>Instagram</span>
      </a>
      <a class="link-row" href="https://facebook.com/twogetherflowers" target="_blank" rel="noopener">
        <img src="assets/facebook-icon-black.svg" alt="" aria-hidden="true" />
        <span>Facebook</span>
      </a>
      <a class="link-row" href="https://www.tiktok.com/@twogetherflower" target="_blank" rel="noopener">
        <img src="assets/tiktok-icon-black.svg" alt="" aria-hidden="true" />
        <span>TikTok</span>
      </a>
      <a class="link-row" [href]="website" target="_blank" rel="noopener">
        <span class="web-icon" aria-hidden="true">www</span>
        <span>Weboldal</span>
      </a>
      <a class="link-row" [href]="webshop" target="_blank" rel="noopener">
        <span class="web-icon" aria-hidden="true">shop</span>
        <span>Webshop</span>
      </a>
      <a class="link-row" [href]="wolt" target="_blank" rel="noopener">
        <span class="web-icon" aria-hidden="true">W</span>
        <span>Wolt rendelés</span>
      </a>
      <a class="link-row" [href]="'mailto:' + email">
        <span class="mail-icon" aria-hidden="true">@</span>
        <span>{{ email }}</span>
      </a>
    </div>

    <address>
      1138 Budapest, Cserhalom utca - Mura utca sarka
    </address>
  </section>
</main>
